import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { TableService } from '../../services/table.service';
import { GenericQueryParams } from '../../utils/utils';
import { currentAccountsTableConfig } from './currentAccountsTableConfig';

@Component({
  selector: 'page-current-accounts',
  templateUrl: 'current-accounts.html',
})
export class CurrentAccountsPage {
  private navControllerService: NavControllerService;
  public tableHeaders = currentAccountsTableConfig;

  private pageName: string = 'page-current-accounts';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private translate: TranslateService,
    public storage: Storage,
    private app: App,
    public tableService: TableService
  ) {
    this.navControllerService = new NavControllerService(app, storage);
  }

  currentAccountsQueryFn() {
    return (params: GenericQueryParams) => this.backendService.getPaginatedCurrentAccounts(params);
  }

  showCurrentAccountDetails(currentAccount: CurrentAccount) {
    this.navControllerService.showCurrentAccountDetails(currentAccount.uuid);
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/current-accounts/current-accounts.ts